<template>
  <!--
    The sign-in screen is the ONLY shop surface that carries the LINE button.
    It used to live in CustomerSidemenu, which put it on every layout
    "customer" page - my page, sign up, the side menu itself - and that was
    wrong: it belongs under the login form, not beside the navigation.

    Consequence worth knowing: with the side-menu copy gone, the shop_my_page
    and shop_side_menu origins have no entry point left in the UI. They are
    still valid in Line::ORIGINS and LineController still routes them, so a
    surface can be added back later without touching the backend.
  -->
  <div class="login-form">
    <customer-sign-in type="shop"></customer-sign-in>

    <line-login-button origin="shop_sign_in" />
  </div>
</template>

<script lang="ts" setup>
import { computed, watch } from "vue";

import { useAuthStore } from "@/stores/auth";
import { useBaseInfoStore } from "@/stores/base_info";

import CustomerSignIn from "@/components/organisms/pages/customer/CustomerSignIn.vue";
import LineLoginButton from "@/components/molecules/line/LineLoginButton.vue";

import { useTitle } from "@vueuse/core";

const authStore = useAuthStore();

const baseInfoStore = useBaseInfoStore();

const baseInfo = computed(() => baseInfoStore.baseInfo);

if (authStore.isLoggedIn) {
  window.location.href = authStore.originalUrl ? authStore.originalUrl : "/shop/customer";

  authStore.clearOriginalUrl();
}

watch(
  baseInfo,
  (value) => {
    if (value) {
      useTitle(value?.shopName);
    }
  },
  { immediate: true },
);
</script>

<style lang="scss" scoped>
.login-form {
  max-width: 700px;
  margin: auto;
  margin-top: 40px;
}
</style>
